import { guard } from "effector";
import { audioEnded } from "frontend/src/domain/audio";
import { $playerHasNextTrack } from "frontend/src/domain/player-track-queue";
import { pause } from "frontend/src/features/control-audio";
guard({
    clock: audioEnded,
    source: $playerHasNextTrack,
    filter: function (playerHasNextTrack) { return !playerHasNextTrack; },
    target: pause,
});
